import React from 'react';
import AboutUsSection from './sections/about-us-section';
import BannerSection from './sections/banner-section';
import LaundryServicesSection from './sections/laundry-services-section';
import ReviewSection from './sections/review-section';
import TrustSection from './sections/trust-section';
import HowWeWorksSection from './sections/how-we-works-section';
import CategoriesSection from './sections/categories-section';
import ServiceSections from './sections/service-sections';
import SafetySection from './sections/safety-section';
import TestimonialSection from './sections/testimonial-section';
import MobileAppSection from './sections/mobile-app-section';
import Header3 from '@/feature-module/common/header/header-3';

const HomeThemeThree = (props: any) => {
  const { themeData, collections } = props;
  return (
    <>
      {/* <Header3 themeData={themeData} /> */}
      <div className="sec-home home-three-main-wrapper">
        <BannerSection themeData={themeData} />
        <LaundryServicesSection themeData={themeData} />
        {/* <ReviewSection themeData={themeData} /> */}
        <TrustSection themeData={themeData} />
        <HowWeWorksSection themeData={themeData} />
        <CategoriesSection themeData={themeData} />
        <AboutUsSection themeData={themeData} />
        <ServiceSections themeData={themeData} />
        <SafetySection themeData={themeData} />
        <TestimonialSection themeData={themeData} />
        <MobileAppSection themeData={themeData} />
      </div>
    </>
  );
};

export default HomeThemeThree;
